export const curriculumFaqs = [
  {
    question: 'Are these real projects or toy demos?',
    answer:
      'Real. They run on real systems — Notion / Google Drive, a live helpdesk, GitHub, AWS, LiveKit, Stripe test mode, a CRM, an issue tracker — are deployed, and ship with evaluation reports and metrics.',
  },
  {
    question: 'Do I have to pay for tools, APIs or cloud?',
    answer: 'No — all necessary credits and access required to complete the projects, like API credits, are already included in your program.',
  },
  {
    question: 'Can I show this work to employers?',
    answer:
      'Yes. Each project leaves a GitHub repository, a live deployment (or a recording), an eval report, a one-page spec and a demo narrative. The guided projects and your capstone form your interview portfolio.',
  },
  {
    question: 'Which projects impress interviewers most?',
    answer:
      "VoiceMate (the live demo), ShipIt ('deployed on AWS with monitoring'), TriageOps and GateKeeper MCP (enterprise-grade agents with permissions), RepoAgent (coding agents in a real codebase) — and your capstone.",
  },
  {
    question: 'Do I choose my projects?',
    answer:
      'Mini projects and guided projects are fixed, so every graduate has the same proven core. The capstone is your choice — from the menu or bring your own — and the four optional builds are self-selected.',
  },
  {
    question: 'How much time do the projects take?',
    answer: 'About 20 hours of take-home per sprint alongside 10 live sessions — roughly 120 hours of building across the program, plus the optional builds.',
  },
  {
    question: 'Are the projects AWS-specific?',
    answer:
      'Concepts are cloud-neutral; AWS (Bedrock/AgentCore, SageMaker) is the hands-on cloud, so every graduate has one real cloud deployment. Azure and GCP are compared conceptually.',
  },
  {
    question: 'What if I already know some of this?',
    answer:
      'The guided projects go deeper than most working engineers have gone — evals in CI, multi-tenant MCP, fine-tuning economics, voice latency engineering. If you are experienced, take on the stretch goals and the optional builds.',
  },
];

export default curriculumFaqs;
